import script from "./index.vue?vue&type=script&setup=true&name=GameScreen&lang=js"
export * from "./index.vue?vue&type=script&setup=true&name=GameScreen&lang=js"

import "./index.vue?vue&type=style&index=0&id=6d0ea7a8&scoped=true&lang=css"
import "./index.vue?vue&type=style&index=1&id=6d0ea7a8&scoped=true&lang=css"

import exportComponent from "/Users/nasinet/hujing_pro/hj_pro_h5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6d0ea7a8"]])

export default __exports__